import { RestClient, RequestResponse } from "@infrastructure/clients/http/clients/base/rest.client";
import { CommonDto } from "@infrastructure/clients/http/common.dto";
import { BASE_URL } from "@infrastructure/clients/http/config";
import {
  UserResponseSchema,
  UpdateUserRequestSchema,
  UpdateUserResponseSchema
} from "@infrastructure/clients/http/clients/user.schemas";
import * as z from "zod";

class UserClientClass extends RestClient {
  baseUrl = BASE_URL;

  async getCurrentUser(): Promise<RequestResponse<z.infer<typeof UserResponseSchema>>> {
    const result = await this.request("GET", "/api/users/me");
    return this.validateResponse(result, CommonDto.withStatus(UserResponseSchema));
  }

  async updateUser(payload: z.infer<typeof UpdateUserRequestSchema>): Promise<RequestResponse<z.infer<typeof UpdateUserResponseSchema>>> {
    const result = await this.request(
      "PUT",
      "/api/users/me",
      {
        jsonPayload: payload,
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(UpdateUserResponseSchema));
  }
}

export class UserClient extends UserClientClass {}
